import { css, cx } from "@emotion/css"
import { chartStyles } from "../../styles"
import { ReactElement } from "react"
import { Box } from "@material-ui/core"

const styles = {
  container: css`
    display: flex;
    width: 100%;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-xxl-2);
    background-color: var(--extra-dark-grey-2);
    border-radius: 20px 20px 20px 20px;
  `,
}

export const EmptyReponseView = ({
  icon,
  title,
  subTitle,
}: {
  icon: ReactElement
  title: string
  subTitle: string
}) => {
  return (
    <Box className={styles.container}>
      {icon}
      <div
        style={{ marginTop: "var(--spacing-xl)" }}
        className={cx("HeadingH5Bold", chartStyles.title)}
      >
        {title}
      </div>
      <div className={cx("HeadingH5Bold", chartStyles.subTitle)}>
        {subTitle}
      </div>
    </Box>
  )
}
